/**
 * Custom Bundle Logic for Mix & Match Selector
 * Tracks selected items across multiple dynamic groups (radio/checkbox) and handles the unified cart submission.
 */

// --- CONFIGURATION ---
const MAIN_PRODUCT_FORM_SELECTOR_1 = ('#product-form-template--25343278743862__main'); 
const MAIN_PRODUCT_FORM_SELECTOR_2 = ('#product-form-template--25343278842166__main'); 
const combinedSelector = `${MAIN_PRODUCT_FORM_SELECTOR_1}, ${MAIN_PRODUCT_FORM_SELECTOR_2}`;  

    const mainProductForm = document.querySelector(combinedSelector);
// '#product-form-template--25343278842166__main'
// Note: MIN_BUNDLE_ITEMS and DISCOUNT_PERCENTAGE are removed as requested.
// -----------------------

// A data structure (Map) to hold the currently selected items: {productId: {variantId, price, title}}
let selectedBundleItems = new Map();
// Element selectors (these should exist once the bundle is rendered)
const bundleWrapper = document.querySelector('.bundle-selector-wrapper');

const summaryCount = document.getElementById('bundle-count');
const summaryDiscount = document.getElementById('bundle-discount');
const summaryTotal = document.getElementById('bundle-total');

//const discountPercent = parseFloat(input.dataset.discountPercent || 0);

// --- INITIALIZATION ---
document.addEventListener('DOMContentLoaded', initializeBundleListeners);
document.addEventListener('shopify:section:load', initializeBundleListeners); // Re-initialize on theme editor updates


function initializeBundleListeners() {

    if (mainProductForm) {
        mainProductForm.addEventListener('change', (event) => {
            // Check if the change happened to a variant selector or quantity input
            if (event.target.name === 'id' || event.target.name === 'quantity') {
                // Wait briefly for the theme to update the price HTML before reading it
                setTimeout(updateBundleSummary, 100); 
            }
        });
    }
        // Safety check to prevent re-attaching listeners
    if (mainProductForm && !mainProductForm.hasAttribute('data-bundle-listeners-attached')) {
        console.log(mainProductForm);
        //   attachQuantityButtonListeners(); // 💡 CRITICAL: Call the new function here
        mainProductForm.addEventListener('click', handleUnifiedCartSubmission, true);
        mainProductForm.addEventListener('submit', handleUnifiedCartSubmission, true);
        
        mainProductForm.setAttribute('data-bundle-listeners-attached', 'true');
        console.log('Bundle listeners attached via CLICK and SUBMIT (Capture).');

            initializeDefaultSelections();
            // 2. Attach listeners for bundle selection/variant changes
            if (bundleWrapper) {
            bundleWrapper.addEventListener('change', (event) => {
                // Handle selection change (radio/checkbox)
                if (event.target.classList.contains('bundle-selection-input')) {
                    handleSelection(event.target);
                }
                // Handle variant selector change
                if (event.target.classList.contains('bundle-variant-selector')) { 
                    updateVariantSelection(event.target);
                }
            });
        }
    }
    updateBundleSummary();
    attachCardListeners();
    saveBundleToLocalStorage();
    // Initial pricing update (runs on load/refresh)

}


function attachCardListeners() {
    // 1. Select ALL product cards on the page
    const allCards = document.querySelectorAll('.bundle-item-card');
    
    allCards.forEach(card => {
        // 2. Prevent attaching the listener multiple times (important!)
        if (card.hasAttribute('data-card-listener-attached')) {
            return;
        }
        
        // 3. Attach the specific click listener to the individual card
        card.addEventListener('click', handleCardClick);
        card.setAttribute('data-card-listener-attached', 'true');
        
        // 4. Also attach a change listener for the variant dropdowns inside the card
        const variantSelector = card.querySelector('.bundle-variant-selector');
        if (variantSelector) {
            variantSelector.addEventListener('click', (event) => {
                event.stopPropagation(); // Prevent card click when clicking the selector
            });
            // We still need the change event handled by the bundleWrapper listener 
        }

        // 3. Attach a listener directly to the quantity wrapper
        // const quantityWrapper = card.querySelector('.quantity-field');
        //  if (quantityWrapper) {
        //     quantityWrapper.addEventListener('click', (event) => {
               
        //         event.stopPropagation(); // Prevent card click when clicking the quantity area
        //         handleCardQuantityClick(event);
        //         updateBundleSummary();
        //     });
        //  }
    });

    attachQuantityButtonListeners();
}



function attachQuantityButtonListeners() {

    if (bundleWrapper) {
        bundleWrapper.addEventListener('click', (event) => {
            const button = event.target.closest('.quantity-btn');
            
            if (!button) return;

            event.stopPropagation();
            
            const quantityWrapper = button.closest('.quantity-field');
            console.log(quantityWrapper);

            // 🛑 FIX: Check if quantityWrapper is null before querying its children
            if (!quantityWrapper) {
                console.error("Error: Could not find the required '.quantity-field' wrapper. Check HTML structure.");
                return; // Stop execution if the wrapper is missing
            }

            const displayInput = quantityWrapper.querySelector('.bundle-item-quantity-display');
            const productId = quantityWrapper.dataset.productId;

            let currentQty = parseInt(displayInput.value, 10);
            const minQty = parseInt(displayInput.min, 10) || 1;
            const maxQty = parseInt(displayInput.max, 10) || 99;

            let newQty = currentQty;

            if (button.classList.contains('quantity-btn--plus')) {
                newQty = Math.min(currentQty + 1, maxQty);
            } else if (button.classList.contains('quantity-btn--minus')) {
                newQty = Math.max(currentQty - 1, minQty);
            }

            if (newQty !== currentQty) {
                displayInput.value = newQty;
                
                // 3. Update the quantity in the selectedBundleItems Map
                if (selectedBundleItems.has(productId)) {
                    const itemData = selectedBundleItems.get(productId);
                    itemData.quantity = newQty;
                    selectedBundleItems.set(productId, itemData);
                    quantity: newQty
                }

                // 4. Trigger the summary update immediately
                updateBundleSummary(); 
            }
        });
    }
}


function handleCardClick(event) {
    // 1. Find the deepest element that was clicked
    const clickedElement = event.target;
 
    // 2. EXCLUSION: If the click target is the variant selector (dropdown) or any of its children, DO NOTHING.
  if (event.target.closest('.quantity-btn') || 
        event.target.closest('.bundle-item-quantity-display') ||
        event.target.closest('.bundle-variant-selector')) {
        
        // Let the specific element's handler take over and prevent the card logic from running
        return; 
    }
    
    // 3. Find the associated selection input
    const card = event.currentTarget; // The card itself, where the listener is attached

    const input = card.querySelector('.bundle-selection-input');

    if (input) {
        // 4. Toggle/Select the input state
        if (input.type === 'checkbox') {
            input.checked = !input.checked; 
        } else if (input.type === 'radio') {
            input.checked = true;
        }
        
        // 5. Process the new state by calling the handler directly
        // We ensure all visual and Map updates happen
        handleSelection(input);
    }
}

// --- PRICE & SELECTION UTILITIES ---

/**
 * Finds the price for a variant from the selected option element.
 * Assumes the price is stored in cents on the data-price attribute set by Liquid.
 */
function getItemPrice(optionElement) {
    // Safely parse price from either data-price (from <option>) or data-default-price (from <input>)
    const priceInCents = parseInt(optionElement.dataset.price || optionElement.dataset.defaultPrice);
   
    if (!isNaN(priceInCents)) {
      
        return priceInCents;
    } 
    
    console.error("Price retrieval failed for element:", optionElement);
    return 0; 
}

/**
 * Updates the selected variant ID and price when a dropdown changes.
 */

function updateVariantSelection(selector) {
  console.log('inputElement');
  const card = selector.closest('.bundle-item-card');
  const productId = card.dataset.productId;
  const selectedOption = selector.options[selector.selectedIndex];
  const newVariantId = parseInt(selectedOption.value);
  const selectedProductTitle = selectedOption.text.split(' - ')[0].trim();
  const newPrice = getItemPrice(selectedOption);

  // 🛑 FIX: Safely retrieve the discount percentage from the input element
  const inputElement = card.querySelector('.bundle-selector-input-wrapper' > '.bundle-selection-input');

  // Check if inputElement exists before accessing its dataset
  const discountAmount = inputElement ? parseFloat(inputElement.dataset.discount || 0) : 0; 
  const newSku = selectedOption.dataset.sku || "";

  console.log(inputElement);
  if (inputElement && inputElement.checked) {
    // Check if the input is a radio button and ensure it's selected
    if (inputElement.type === 'radio' && !inputElement.checked) {
         return; 
    }

    // Update Map with the new variant and price, including the discount rate
    selectedBundleItems.set(productId, { 
      variantId: newVariantId, 
      price: newPrice,
      title: selectedProductTitle,
      discount: 0,
      sku: newSku
    });
    updateBundleSummary();
  }
}


/**
 * Scans the DOM on initial load to find all default selections (checked radio buttons)
 * and populates the selectedBundleItems Map.
 */
function initializeDefaultSelections() {
    // Select all radio inputs that are initially checked
    const defaultRadioInputs = document.querySelectorAll('.bundle-selection-input[type="radio"]:checked');

    defaultRadioInputs.forEach(input => {
        const card = input.closest('.bundle-item-card');
        const productId = card.dataset.productId;

        // If the item is already selected, don't re-process
        if (selectedBundleItems.has(productId)) {
            return;
        }

        // Get the variant data (logic similar to handleSelection)
        const selector = card.querySelector('.bundle-variant-selector');
        let variantId;
        let variantPrice;
        let selectedProductTitle;
        let discount;
        let quantity;
        let sku;

        if (selector) {
            // Product has variants: read the currently selected option (which should be the default)
            const selectedOption = selector.options[selector.selectedIndex];
            variantId = parseInt(selectedOption.value);
            variantPrice = getItemPrice(selectedOption);
            selectedProductTitle = selectedOption.text.split(' - ')[0].trim();
             discount = parseInt(input.dataset.discount);
             quantity = parseInt(input.dataset.quantity);
             sku =  input.dataset.sku || "";
        } else {
            // No variants: read directly from input attributes
            variantId = parseInt(input.dataset.variantId);
            variantPrice = getItemPrice(input);
            selectedProductTitle = input.dataset.defaultTitle;
            discount = parseInt(input.dataset.discount);
            quantity = parseInt(input.dataset.quantity);
            sku =  input.dataset.sku || "";

        }

        // Add the default selection to the map
        if (variantId) {
            selectedBundleItems.set(productId, {
                variantId: variantId,
                price: variantPrice,
                title: selectedProductTitle,
                discount: discount,
                quantity: quantity,
                sku: sku
            });
            card.classList.add('selected_item'); // Also visually mark it as selected
        }
    });

    // Run the summary update immediately after initialization
    updateBundleSummary();
}

/**
 * Handles the logic when a customer checks/unchecks an item.
 */
/**
 * Handles the logic when a customer checks/unchecks an item.
 */
/**
 * Handles the logic when a customer checks/unchecks an item.
 */
function handleSelection(input) {
   
  try {
    const card = input.closest('.bundle-item-card');
    const productId = card.dataset.productId;
    const sku = input.dataset.sku || "";
    const groupId = card.dataset.groupId; // Get the unique group ID
    // 1. Determine Variant Data (Logic remains robust)
    const selector = card.querySelector('.bundle-variant-selector');
    let variantId;
    let variantPrice;
    let selectedProductTitle;
    let discountAmount;


    // =================================================================
    // 🌟 Quantity Handling 🌟
    // =================================================================
    const quantityDisplayInput = card.querySelector('.bundle-item-quantity-display');
    let quantity = 1; // Default to 1 if the input is not found

    if (quantityDisplayInput) {
        // Read the current value, parse it to an integer, and default to 1 if parsing fails (e.g., if value is blank)
        quantity = parseInt(quantityDisplayInput.value, 10) || 1; 

        // Ensure quantity is never less than 1
        if (quantity < 1) {
            quantity = 1;
            quantityDisplayInput.value = 1; 
        }
    }
    // =================================================================

    if (selector) {
        const selectedOption = selector.options[selector.selectedIndex];
        variantId = parseInt(selectedOption.value);
        variantPrice = getItemPrice(selectedOption);
        selectedProductTitle = selectedOption.text.split(' - ')[0].trim();
    } else {
        variantId = parseInt(input.dataset.variantId);
        variantPrice = getItemPrice(input); 
        selectedProductTitle = input.dataset.defaultTitle;
         discountAmount = input ? parseFloat(input.dataset.discount || 0) : 0; 
    }

    // 2. Core Selection Logic
    if (input.checked) {
     
      // 🛑 FIX FOR RADIO BUTTON: Remove previous selection from this group/map
      if (input.type === 'radio') {
          
          // A. Remove all items from the map that belong to this group
          const idsToRemove = [];
        
          selectedBundleItems.forEach((item, id) => {
            
              const itemCard = document.querySelector(`.bundle-item-card[data-product-id="${id}"]`);
              if (itemCard && itemCard.dataset.groupId === groupId) {
                   idsToRemove.push(id);
              }
          });
          idsToRemove.forEach(id => selectedBundleItems.delete(id));
          
          // B. Remove the 'selected' CSS class from all cards in this group
          document.querySelectorAll(`.bundle-item-card[data-group-id="${groupId}"]`).forEach(siblingCard => {
              siblingCard.classList.remove('selected_item');
          });
      }

      // Add the currently selected item
      selectedBundleItems.set(productId, { 
        variantId: variantId, 
        price: variantPrice, 
        title: selectedProductTitle, 
        discount: discountAmount,
        quantity: quantity,
        sku: sku
      });
      card.classList.add('selected_item');
      
    } else {
      // DESELECT: Only runs for unchecked checkboxes
      selectedBundleItems.delete(productId);
      card.classList.remove('selected_item');
    }
    
    // 3. Update UI
    updateBundleSummary();
    saveBundleToLocalStorage();
  } catch (e) {
    console.error("CRITICAL CRASH in handleSelection! Error:", e.message, e);
    // Safety Fallback
    if (input.checked) { input.checked = false; }
  }
}

async function getInitialMainProductPrice(timeoutMs = 5000, intervalMs = 100) {
    const startTime = Date.now();
    const selector = '.product-page-info__price';

    // Helper to check and process the price
    const checkAndProcess = () => {
     const priceElement = document.querySelector(selector);


    if (priceElement) {
        // Find all immediate span children using the child combinator (>) and :scope
        const spanChildren = priceElement.querySelectorAll(':scope > span');
        const spanCount = spanChildren.length;
        let discountText = null;
        let defaultText = null;
        
        for(let i = 0; i < spanCount; i++){
            // targetText = spanChildren[1].textContent || spanChildren[1].innerText;
           if (i == 0) {
            // Case 1: Two or more spans exist
            // Read the content of the SECOND span (index 1)
            defaultText = spanChildren[0].textContent || spanChildren[0].innerText;

           }else if(i == 1){
            discountText = spanChildren[1].textContent || spanChildren[1].innerText;

           }else {
            // Case 2: Only one span exists
            // Read the content of the FIRST span (index 0)
            defaultText = spanChildren[0].textContent || spanChildren[0].innerText;
            console.log("Reading first span (Index 0).");
            
        }
        }
        
        if (defaultText !== null ) {

            // --- YOUR PRICE PROCESSING LOGIC GOES HERE ---
            // Clean the text and convert it to cents
            let cleanedPrice = defaultText.trim().replace(/[^0-9.]/g, ''); 
            let priceValue = parseFloat(cleanedPrice);
            let price = Math.round(priceValue * 100);
            //console.log(discountText);
            //let cleanedDiscount = discountText.trim().replace(/[^0-9.]/g, ''); 
            const cleanedDiscount = discountText ? String(discountText).trim().replace(/[^0-9.]/g, '') : 0;
            //let cleanedDiscount = typeof discountText === 'string' && discountText.trim() || 0;
            let discountValue = parseFloat(cleanedDiscount);
            let discount = Math.round(discountValue * 100);

            let priceArray = {'price': price, 'discount': discount};

            
            if (!isNaN(priceValue)) {
                // Return the price in cents
                
                return priceArray;
            }
        }
    }
    
    return null; // Element not found or price not valid
    };

    return new Promise(resolve => {
        // 1. Check immediately
        const initialPrice = checkAndProcess();
        if (initialPrice !== null) {
            return resolve(initialPrice);
        }

        // 2. Start polling
        const interval = setInterval(() => {
            const foundPrice = checkAndProcess();

            if (foundPrice !== null) {
                clearInterval(interval);
                return resolve(foundPrice);
            }

            // 3. Check for timeout
            if (Date.now() - startTime > timeoutMs) {
                clearInterval(interval);
                console.warn("Timeout reached. Main product price element not found within the time limit.");
                return resolve(0); // Return 0 on timeout
            }
        }, intervalMs);
    });
}

/**
 * Recalculates the total price and updates the summary bar visibility/display.
 */
async function updateBundleSummary() {
    let totalCount = 0;
    // --- Local Calculations ---
    let mainProductPriceCents = await getInitialMainProductPrice(); 
    let priceDisplay = mainProductPriceCents.price;
    let discountDisplay = mainProductPriceCents.discount;

    let componentTotalFullPriceCents = 0; // The total full price of all selected components
    let totalDiscountCents = 0; // Total savings amount
    let totalWithDiscount = 0;
    let itemQuantity = 0;
    // let quantity = 0;
    // 1. Calculate Component Totals and Discount from the Map
    selectedBundleItems.forEach((item, productId) => {
        const quantity = item.quantity || 1;
        componentTotalFullPriceCents += item.price * quantity ; 
        totalCount += quantity;
        // Calculate and accumulate discount
        const itemDiscountRate = item.discount || 0; 

        if (itemDiscountRate > 0) {
            
            const itemDiscountCents = Math.round(itemDiscountRate * quantity);
            // if (itemDiscountCents.startsWith('A$')) {
            //     itemDiscountCents = itemDiscountCents.substring(1); // Removes the first character ('A')
            // }
            totalDiscountCents += parseInt(itemDiscountCents);
            
        }
    });
    // 2. Calculate Final Display Price
    // Final Price = (Main Product Price + Full Component Price) - Total Discount

    let AddedPrices = priceDisplay + componentTotalFullPriceCents;
    let AddedPricesDiscount = discountDisplay + componentTotalFullPriceCents ;
    // if(dicountDisplay > 0){
    //    AddedPrices = dicountDisplay + componentTotalFullPriceCents;
    // }
    let finalDisplayPriceCents = Math.round(AddedPrices) ;
    let finalDisplayDiscount = Math.round(AddedPricesDiscount);

    console.log(finalDisplayPriceCents);
    // --- Visibility and Display Logic ---
    const summaryArea = document.querySelector('.bundle-final-summary-area');

    if (summaryArea) {
        // Show summary only if components have been selected
        //summaryArea.style.display = totalCount > 0 ? 'block' : 'none';
    }

    // Format price
    const locale = (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : 'en-AU';
    const currency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'AUD';

    let formatter;
    try { formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); } catch (e) {
        formatter = { format: (cents) => `$${(cents / 100).toFixed(2)}` };
    }
    summaryDiscount.classList.add('d-none');
    let savingsText = '';

    let finalDisplayWithoutDiscount = finalDisplayPriceCents + totalDiscountCents;
    if (totalDiscountCents > 0 || discountDisplay > 0) {

        totalWithDiscount = finalDisplayPriceCents;
        //totalWithDiscount = finalDisplayDiscount;
        if(discountDisplay > 0){
        totalWithDiscount = finalDisplayDiscount;
        }
       
       totalDiscountCents = formatter.format(totalDiscountCents / 100);
          if (totalDiscountCents.startsWith('A$')) {
         savingsText = `${totalDiscountCents.substring(1)}`; // Removes the first character ('A')
    }
    //  summaryDiscount.classList.remove('d-none');
    //  summaryDiscount.textContent = `- ${savingsText}`;
    }

    //const itemDiscountCents = Math.round(itemDiscountRate);
      
    // Update main button text
    //const mainProductForm = document.querySelector(MAIN_PRODUCT_FORM_SELECTOR);
    if (mainProductForm) {
        const submitButton = mainProductForm.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.textContent = `Add Bundle to Cart`;
        }
    }
    
    // Update summary display elements
    if (summaryCount) {
        summaryCount.textContent = totalCount > 0 ? `+ ${totalCount} Bundle - Save ${savingsText}` : `Selected: 0 item(s)`;
    }

    if (totalDiscountCents !== 0 || discountDisplay !== 0) {
       // console.log("total is less than 0");
      summaryDiscount.classList.remove('d-none');
      summaryTotal.classList.add('strikethrough');
    }else{
        //console.log("total is more than 0");
      summaryDiscount.classList.add('d-none');  
      summaryTotal.classList.remove('strikethrough');
    }
    
    
    if (summaryTotal) {

    
    let formattedTotalWithDiscount = formatter.format((totalWithDiscount) / 100);
    let formattedPrice = formatter.format((finalDisplayWithoutDiscount) / 100);
    
    // Check if the price starts with "A$" and remove the 'A'
    if (formattedPrice.startsWith('A$')) {
        formattedPrice = formattedPrice.substring(1); // Removes the first character ('A')
    }

      if (formattedTotalWithDiscount.startsWith('A$')) {
        formattedTotalWithDiscount = formattedTotalWithDiscount.substring(1); // Removes the first character ('A')
    }




    summaryDiscount.textContent = `${formattedTotalWithDiscount}`;
    summaryTotal.textContent = formattedPrice;
    }
}


// --- CART SUBMISSION LOGIC ---

/**
 * Handles the Unified Cart Submission (Main Product + Bundle Items).
 */
/**
 * Calculates the total monetary discount (in cents) for all selected items
 * that have a discount rate > 0.
 */
// function calculateTotalDiscount() {
//     let totalDiscountCents = 0;
    
//     selectedBundleItems.forEach(item => {
//         // item.price is the full price in cents (from Liquid's data-price attribute)
//         // item.discount is the decimal rate (e.g., 0.15)
//         console.log(item);
//         if (item.discount && item.discount > 0) {
//             // Only apply discount math if the discount is explicitly set and positive
//             const itemDiscountCents = Math.round(item.price * item.discount);
//             totalDiscountCents += itemDiscountCents;
//         }
//     });
//     return totalDiscountCents;
// }

/**
 * Handles the Unified Cart Submission (Main Product + Bundle Items).
 * This function calculates the total discount from all bundle items and
 * submits the required components and the negative price line item.
 */

window.addEventListener('beforeunload', () => {
    localStorage.removeItem('bundle_items');
    // Or if you want to clear the Map in memory too (though the page is dying anyway)
    selectedBundleItems.clear();
});

function saveBundleToLocalStorage() {
 
    const itemsArray = Array.from(selectedBundleItems.entries()).map(([productId, item]) => ({
        id: productId.toString(), // Ensuring it matches your string ID format
        qty: item.quantity || 1,
        sku: item.sku || ""
    }));
    
    localStorage.setItem('bundle_items', JSON.stringify(itemsArray));
}

function handleUnifiedCartSubmission(event) {
    // event.preventDefault(); 
    // event.stopImmediatePropagation(); 

    // //const mainProductForm = document.querySelector(MAIN_PRODUCT_FORM_SELECTOR); 
    // const submitButton = event.target; 
    // 1. Identify the trigger
    const submitButton = mainProductForm.querySelector('.js-product-button-add-to-cart');
    
    // 2. GUARD CLAUSE: 
    // If it's a click event, check if the clicked element (or its parent) is our specific button.
    // If it's a submit event, we still want to make sure it wasn't triggered by a different action.
    if (event.type === 'click' && !event.target.closest('.js-product-button-add-to-cart')) {
        return; // Exit and let other buttons (like Quote) function normally
    }

    event.preventDefault(); 
    event.stopImmediatePropagation();

    if (!mainProductForm) {
        console.error(`Form with selector ${mainProductForm} not found.`);
        submitButton.disabled = false;
        return; 
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Adding Bundle...';

    const itemsPayload = [];

    // --- 1. Get and Add the Main Product Item ---
    const formData = new FormData(mainProductForm); 
    const mainVariantId = formData.get('id');
    const mainQuantity = parseInt(formData.get('quantity') || 1);

    if (isNaN(parseInt(mainVariantId))) {
        console.error("Main product variant ID is invalid.");
        submitButton.disabled = false;
        submitButton.textContent = 'Error';
        return;
    }

    itemsPayload.push({
        id: parseInt(mainVariantId),
        quantity: mainQuantity,
        properties: { '_bundle_main': 'true' }
    });

    

  
    // // --- 2. Add Selected Bundle Items (Full Price) ---
     selectedBundleItems.forEach(item => {
          const discountRatePercentage = Math.round((item.discount || 0) * 100);
          const productQuantity = Math.round((item.quantity || 1));
        itemsPayload.push({
            id: parseInt(item.variantId), // Bundle Item's Real Variant ID
            quantity: productQuantity, 
            // properties: {
            //     'Bundle Component': item.title,
            // //     '_bundle_group': 'custom-mix-match-full-price',
            // //    'Discount Rate': `${discountRatePercentage}%`
            // }
        });
    });

    // --- 3. Add the Negative Line Item (The Discount) ---
            // const totalDiscountAmount = calculateTotalDiscount(); 

            // if (totalDiscountAmount > 0) {
            //     const DISCOUNT_PLACEHOLDER_VARIANT_ID = 10399634751798; 

            //     // 🛑 CRITICAL FIX: Ensure the final price is an absolute integer (cents).
            //     const priceToSend = -Math.round(Math.abs(totalDiscountAmount));

            //     itemsPayload.push({
            //         id: parseInt(DISCOUNT_PLACEHOLDER_VARIANT_ID),
            //         quantity: 1, 
            //         price: priceToSend, // Using the forced integer value
            //         properties: {
            //             '_is_discount': 'true', 
            //             'Discount Title': 'Custom Bundle Savings', 
            //             'Savings on Items': selectedBundleItems.size
            //         }
            //     });
            // }

//    console.log('--- PAYLOAD DEBUG START ---');
//     console.log('Total Bundle Discount:', totalDiscountAmount);
//     console.log('Items Payload:', JSON.stringify(itemsPayload, null, 2)); // Prints a readable JSON structure
//     console.log('--- PAYLOAD DEBUG END ---');

fetch('/cart/add.js', { 
    method: 'POST', 
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: itemsPayload })
})
.then(response => {
    if (!response.ok) {
        // Log the response text for detailed server error if needed
        return response.json().then(errorData => {
            throw new Error(errorData.description || 'Failed to add items.');
        });
    }
    return response.json();
})
.then(() => {
    // 🛑 CRITICAL FIX: Direct success handling after primary fetch.
    // The negative price is already in the payload, so we just need to refresh the UI.
    
    submitButton.textContent = 'Added!';
    
    // We only need to refresh the cart to display the new total/discount line.
    refreshCartContent(itemsPayload); 
})
.catch((error) => {
    console.error('Unified Cart Error:', error);
    submitButton.textContent = 'Error!';
    setTimeout(() => {
        alert("Error adding items to cart. Please try again.");
        window.location.reload(); 
    }, 500); 
});
}


/**
 * Builds an object mapping line item keys to their final discounted price (in cents).
 */
function buildPriceUpdates(addedItems) {
    // 🛑 CRITICAL FIX: Ensure 'addedItems' is an array, or default to an empty array if null/undefined.
    const items = Array.isArray(addedItems) ? addedItems : [];
    const updates = {};
    
    // Iterate over the items that were successfully added to the cart
    items.forEach(cartLine => {
        // Find the matching item in your original selected map (by variantId)
        const selectedItem = Array.from(selectedBundleItems.values()).find(
            item => item.variantId === cartLine.variant_id
        );

        // Check if the item was flagged for a discount in your configuration
        if (selectedItem && selectedItem.discount > 0) {
            
            // Calculate final price: Full Price - Discount Amount
            // We use item.price (full price) from the cartLine if available, but the submitted price is safer.
            const discountAmountCents = Math.round(selectedItem.price * selectedItem.discount);
            const finalDiscountedPriceCents = selectedItem.price - discountAmountCents;
            
            // This structure is required by the Cart API to set a new price
            // cartLine.key is the unique identifier for the line item in the cart.
            updates[cartLine.key] = finalDiscountedPriceCents;
        }
    });

    return updates;
}


/**
 * Sends a request to the Cart API to set custom prices on specific line items.
 */
function updateCartLinePrices(updates) {
    // Map the updates object to the format required by Shopify's update endpoint
    const data = {
        updates: updates,
        cart_options: { update_prices: true } // Crucial flag to tell Shopify to accept the custom price
    };

    return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    })
    .then(response => response.json());
}



/**
 * Forces the theme to update cart contents by fetching the latest data.
 */
function refreshCartContent(itemsPayload) {
    // 1. Dispatch custom events that themes often listen for
    document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: itemsPayload } }));
    document.dispatchEvent(new CustomEvent('shopify:cart:add', { bubbles: true, detail: { items: itemsPayload } }));
    
    // 2. Fetch the latest cart data using the AJAX endpoint
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Dispatch event with the new cart data—many themes will update automatically here
            document.dispatchEvent(new CustomEvent('cart:afterAdd', { bubbles: true, detail: { cart: cart } }));

            // 3. Attempt to trigger theme's native cart display logic (Theme-specific guess)
            if (window.theme && typeof window.theme.openCartDrawer === 'function') {
                window.theme.openCartDrawer();
            } else if (window.theme && window.theme.refreshCart) {
                window.theme.refreshCart();
            } else {
                // If we can't find a theme function, redirect to the cart page after a delay.
                setTimeout(() => {
                     window.location.href = '/cart';
                }, 500);
            }
            
            // Restore button state
             const submitButton = document.querySelector('button[type="submit"]:disabled');
             if (submitButton) {
                 setTimeout(() => {
                    submitButton.textContent = 'Add to Cart';
                    submitButton.disabled = false;
                 }, 1500);
             }
        })
        .catch(error => {
            console.error("Failed to fetch cart for update:", error);
            window.location.href = '/cart'; // Force redirect if update fails
        });
    
}